import { Suspense, lazy } from 'react'
import { Switch, Redirect, Route } from 'react-router-dom'
import { Mode } from '@ocean/types/dist/appearance'
import { common } from '@ocean/ui'
import { PrivateRoute } from 'routing/components'
import { PermissionUtils } from 'utils'
import virtualClassroomManagerRoutes from 'modules/virtualClassrooms/common/routing/managerRoutes'
import routes from './routes'

const { RouteChangeProgress } = common

export { routes }

export const List = lazy(
  () =>
    import(
      /* webpackChunkName: "VirtualClassroomManagerSchedulesList" */ 'modules/virtualClassrooms/manager/Schedules/pages/List'
    )
)

export const Create = lazy(
  () =>
    import(
      /* webpackChunkName: "VirtualClassroomManagerSchedulesCreate" */ 'modules/virtualClassrooms/manager/Schedules/pages/Create'
    )
)

export const Edit = lazy(
  () =>
    import(
      /* webpackChunkName: "VirtualClassroomManagerSchedulesEdit" */ 'modules/virtualClassrooms/manager/Schedules/pages/Edit'
    )
)

const SchedulesRouting = () => {
  const virtualClassroomManageEventsDenied = PermissionUtils.virtualClassroomManageEventsDenied()

  return (
    <Suspense fallback={<RouteChangeProgress mode={Mode.Light} />}>
      <Switch>
        <Route exact path={`${routes.list}/:eventId`} component={List} />
        <PrivateRoute
          exact
          path={`${routes.create}/:eventId`}
          component={Create}
          disabled={virtualClassroomManageEventsDenied}
        />
        <PrivateRoute
          exact
          path={`${routes.edit}/:scheduleId`}
          component={Edit}
          disabled={virtualClassroomManageEventsDenied}
        />
        <Redirect path='*' to={virtualClassroomManagerRoutes.events} />
      </Switch>
    </Suspense>
  )
}

export default SchedulesRouting
